<!--
 * @Description: 列表组件，用于首页、全部商品页面的商品列表
 * @Author: hai-27
 * @Date: 2020-02-07 16:23:00
 * @LastEditors: hai-27
 * @LastEditTime: 2020-03-05 01:37:50
 -->
<template>
  <div id="myList" class="myList">
    <ul>
      <li v-for="item in list" :key="item.id" :style="{height:liHeight,width:liImgHeight}">
        <router-link :to="{ path: '/yhpart/partDetail', query: {partId:item.id} }" >
          <!-- <div class="barrier"><span>{{item.otherDesc}}</span></div> -->
          <img :style="{height:liImgHeight}" :src="item.picUrl" alt />
          <h2>{{item.partName}}</h2>
        </router-link>
      </li>
      <div style="clear:both;"></div>
    </ul>
  </div>
</template>
<script>
export default {
  name: "MyList",
  // list为父组件传过来的商品列表
  // isMore为是否显示“浏览更多”
  props: ["list"],
  data() {
    return {
      liHeight: "",
      liImgHeight: ""
    };
  },
  created() {
    this.initLiImgWidth();
  },
  computed: {


  },
  methods: {

    initLiImgWidth() {
      if(window.innerWidth<846) {
        let imgWidth = (window.innerWidth*0.9-36)/2;
        this.liImgHeight = imgWidth+'px';
        let theliHeight = imgWidth+42+30;
        this.liHeight = theliHeight+'px';
      } else if(window.innerWidth<1130) {
        let imgWidth = (window.innerWidth*0.9-50)/3;
        this.liImgHeight = imgWidth+'px';
        let theliHeight = imgWidth+42+30;
        this.liHeight = theliHeight+'px';
      } else {
        this.liImgHeight = '234px';
        this.liHeight = '320px';
      }
    }

  },
  mounted() {
    window.addEventListener('resize',()=>{
      this.initLiImgWidth();
    },false);
  }

};
</script>
<style scoped>

.myList ul li {
  z-index: 1;
  float: left;
  margin: 0 0 14.5px 13.7px;
  background-color: white;
  -webkit-transition: all 0.2s linear;
  transition: all 0.2s linear;
  position: relative;
}
.myList ul li:hover {
  z-index: 2;
  -webkit-box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
  -webkit-transform: translate3d(0, -2px, 0);
  transform: translate3d(0, -2px, 0);
}

.myList ul li:hover .barrier{
  display: block;
}

.myList ul li img {
  width: 100%;
  display: block;
  margin-top: 0px;
  border-radius:10px; 
}

.barrier {
  width: 100%;
  height: 100%;
  position: absolute;
  font-size: 16px;
  text-align: center;
  color: white;
  background-color: black;
  opacity: 0.75;
  filter: alpha(opacity=75);
  display: none;
}

.barrier-hide {
  display: none;
}

.barrier span {
  width: 90%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  text-overflow: ellipsis;
}

.myList ul li h2 {
  margin: 20px 10px 10px;
  font-size: 18px;
  font-weight: 500;
  color: #333;
  text-overflow: ellipsis;
  overflow: hidden;
}
.myList ul li h3 {
  margin: 5px 10px;
  height: 18px;
  font-size: 12px;
  font-weight: 400;
  color: #b0b0b0;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

</style>


// WEBPACK FOOTER //
// src/components/MyList.vue